import React from 'react';
import PropTypes from 'prop-types';
import Carousel from './carousel';

const MultiCarousel = (props) => {
  const { children = [], itemsPerSlide = 3 } = props;
  return (
    <Carousel
      pagination={false}
      itemsPerSlide={itemsPerSlide}
      items={children}
    />
  );
};

MultiCarousel.propTypes = {
  children: PropTypes.object,
  itemsPerSlide: PropTypes.number,
};

export default MultiCarousel;
